var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewPptImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2003 51.1333H11.8003C7.47359 51.1333 3.93359 47.5933 3.93359 43.2666V15.7333C3.93359 11.4066 7.47359 7.86664 11.8003 7.86664H47.2003C51.5269 7.86664 55.0669 11.4066 55.0669 15.7333V43.2666C55.0669 47.5933 51.5269 51.1333 47.2003 51.1333Z",
    fill: "#A576FF",
    stroke: "#A576FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2003 51.1333H11.8003C7.47359 51.1333 3.93359 47.5933 3.93359 43.2666V15.7333C3.93359 11.4066 7.47359 7.86664 11.8003 7.86664H47.2003C51.5269 7.86664 55.0669 11.4066 55.0669 15.7333V43.2666C55.0669 47.5933 51.5269 51.1333 47.2003 51.1333Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8003 51.1334H47.2003C51.5269 51.1334 55.0669 47.5934 55.0669 43.2667V29.5L47.2003 21.6334L26.7469 40.5134L17.7003 31.4667L3.93359 44.0534C4.52359 47.9867 7.67026 51.1334 11.8003 51.1334Z",
    fill: "white",
    fillOpacity: 0.75,
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7663 23.6C15.9387 23.6 17.6997 21.839 17.6997 19.6667C17.6997 17.4944 15.9387 15.7333 13.7663 15.7333C11.594 15.7333 9.83301 17.4944 9.83301 19.6667C9.83301 21.839 11.594 23.6 13.7663 23.6Z",
    fill: "#F6F8F9",
    stroke: "#F6F8F9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M31.3672 28.2852H35.3906V29.6133H31.3672V33.7539H30.0293V29.6133H26.0059V28.2852H30.0293V24.125H31.3672V28.2852Z",
    fill: "#121212",
    fillOpacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPptImg);
export default __webpack_public_path__ + "static/media/new-ppt-img.7ff64dac45830c266ff3a3b26a1b6145.svg";
export { ForwardRef as ReactComponent };